import { dateToString, dateUTCToClient } from 'libs/convertDate';


export const getFullDateWithTime = date => {
	return `${ dateToString(dateUTCToClient(date), 'stringFullDate') }, ${ dateToString(dateUTCToClient(date), 'time') }`;
};